<template>
  <div class="container">
    <div class="section text-center cta bg-cover bg-center dark-overlay dark-overlay-2 bg-parallax"
         v-bind:style="{'background-image': 'url(' + getImagePath('assets/images/promo_bg.jpg') + ')'}">
      <div class="section-title-wrap section-header text-center">
        <h5 class="custom-primary">Zamów przynajmniej 2 pizze</h5>
        <h2 class="title text-white">Otrzymaj je w cenie mniejszego rozmiaru!</h2>
        <p class="subtitle text-white">
          Pizza Mega w cenie Familijnej, Familijna w cenie Dużej, a Duża w cenie Małej.
          <small>Promocja obowiązuje od poniedziałku, do czwartku.</small>
        </p>
      </div>
      <router-link to="/menu" class="btn-custom shadow-none">
        {{ $t('See menu') }}
      </router-link>
    </div>
  </div>
</template>
<script>
import imageMixin from "@/mixins/imageMixin";

export default {
  name: 'promotion1',
  mixins: [imageMixin],
}
</script>
